import React  from 'react';
import haiwaishenbaoliucheng from '../assets/img/haiwaishenbaoliucheng.png';
import xiangmudingdan from '../assets/img/xiangmudingdan.png';
import waimaohetong from '../assets/img/waimaohetong.png';
import caigouhetong from '../assets/img/caigouhetong.png';
import xiangmudingdanchengbenhesuanbiao from '../assets/img/xiangmudingdanchengbenhesuanbiao.png';
import haiwaishenbaoliucheng1 from '../assets/img/haiwaishenbaoliucheng1.png';
import haiwaishenbaoliucheng2 from '../assets/img/haiwaishenbaoliucheng2.png';
import hetongbianzhiguize from '../assets/img/hetongbianzhiguize.png';
const Enclosure621 = () => 
    <div
        style={{
            WebkitTouchCallout:'none',  /*系统默认菜单被禁用*/
            MozUserSelect: 'none',  /*火狐*/
            WebkitUserSelect: 'none',  /*webkit浏览器*/
            msUserSelect: 'none',  /*IE10*/
            khtmlUserSelect: 'none',  /*早期浏览器*/
            userSelect: 'none',
        }}
     >
        <div style={{ textIndent: '2em' }}>
        <img src={haiwaishenbaoliucheng} alt="" style={{ width  : '90%', display: 'block', margin : '0 auto' }}/>
        <br/><br/>
        <h4>1)《海外项目/订单业务申报流程表》 </h4>
        <img src={xiangmudingdan} alt="" style={{ width  : '90%', display: 'block', margin : '0 auto' }}/>
        <br/><br/>
        <h4>2)《外贸合同》 </h4>
        <img src={waimaohetong} alt="" style={{ width  : '90%', display: 'block', margin : '0 auto' }}/>
        <br/><br/>
        <h4>3)《内贸采购合同》 </h4>
        <img src={caigouhetong} alt="" style={{ width  : '90%', display: 'block', margin : '0 auto' }}/>
        <br/><br/>
        <h4>4)《项目/订单成本核算表》 </h4>
        <img src={xiangmudingdanchengbenhesuanbiao} alt="" style={{ width  : '90%', display: 'block', margin : '0 auto' }}/>
        <br/><br/>
        <img src={haiwaishenbaoliucheng1} alt="" style={{ width  : '90%', display: 'block', margin : '0 auto' }}/>
        <br/><br/>
        <h4>（一）签订合同</h4>
        <h4>附件《云湖春煜2020年合同号编制规则》 </h4>
        <img src={hetongbianzhiguize} alt="" style={{ width  : '90%', display: 'block', margin : '0 auto' }}/>
        <img src={haiwaishenbaoliucheng2} alt="" style={{ width  : '90%', display: 'block', margin : '0 auto' }}/>
        </div>
    </div>


export default Enclosure621;